<template>
    <VMap
        :accessToken="mapOptions.accessToken"
        :mapStyle="mapOptions.style"
        :options="mapOptions"
        @loaded="onMapLoaded"
    >
    </VMap>
</template>

<script>
import {createHelpers} from "vuex-map-fields";

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

import {screenSize} from "../../../mixins/screenSize";
import {touchEvent} from "../../../mixins/touchEvent";
import mapbox from 'mapbox-gl';
import 'v-mapbox/dist/v-mapbox.css';
import {VMap, VMarker} from 'v-mapbox';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';

export default {
    name: "modal_courier_map",
    props: {},
    components: {
        VMap,
        VMarker
    },
    mixins: [screenSize, touchEvent],
    data() {
        return {
            statusModalMap: true,
            activeZoneId: 0,
            markerOptions: {
                draggable: false,
                color: "black",
            },
            popupOptions: {
                options: {
                    closeButton: false,
                    closeOnClick: true,
                    closeOnMove: true,
                },
                content: "",
            },
            mapOptions: {
                center: [
                    0,
                    0
                ],
                attributionControl: false,
                preserveDrawingBuffer: true,
                hash: false,
                zoom: 1,
                container: "map",
                style: "mapbox://styles/tbiliso/ckiufb2m82toh19oz1qjkywos",
                accessToken: "pk.eyJ1IjoibG9payIsImEiOiJjamh6dnF4cGwwM3JtM3BwaTg4b28zNXdhIn0.OvClW1t-Lxss_VhXQHBAwQ",
            },
            currentUserLocation: {},
            isMapLoad: false,
        }
    },
    created() {
        this.mapbox = null;
        this.mapOptions.center[0] = this.coordinateRest.lng;
        this.mapOptions.center[1] = this.coordinateRest.lat;
        this.mapOptions.zoom = 13;
    },
    mounted() {
    },
    methods: {
        moveTouchDown() {
            this.closeModalMap();
        },
        closeModalMap() {
            this.statusModalMap = false;
        },
        onMapLoaded(map) {
            this.mapbox = map;
            this.isMapLoad = true;
            this.addDirections();
        },
        async addDirections() {
            if (!this.coordinateRest || !this.coordinateDelivery) return;

            const directions = new MapboxDirections({
                accessToken: this.mapOptions.accessToken,
                unit: 'metric',
                profile: 'mapbox/driving',
            });
            this.mapbox.addControl(directions, 'top-left');
            directions.setOrigin([this.coordinateRest.lng, this.coordinateRest.lat]);
            directions.setDestination([this.coordinateDelivery.lng, this.coordinateDelivery.lat]);
        }
    },
    computed: {
        ...mCouriers([
            'activeCourierOrderInfo'
        ]),
        coordinateRest() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.pos_restaurant.coordinate')
                && this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.pos_restaurant.coordinate.lat')
                && this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.pos_restaurant.coordinate.lng')) {
                return {
                    lat: this.activeCourierOrderInfo.order.pos_restaurant.coordinate.lat,
                    lng: this.activeCourierOrderInfo.order.pos_restaurant.coordinate.lng
                }
            }
            return {lat: 0, lng: 0};
        },
        coordinateDelivery() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.delivery')
                && this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.delivery.lat')
                && this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.delivery.lng')) {
                return {
                    lat: this.activeCourierOrderInfo.order.delivery.lat,
                    lng: this.activeCourierOrderInfo.order.delivery.lng
                }
            }
            return {lat: 0, lng: 0};
        }
    },
}
</script>
